<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 v-if="!current.codigo" class="form-header">Nueva Tienda</h5>
                <div v-if="!current.codigo" class="form-desc">
                  Adición Tienda
                </div>
                <h5 v-if="current.codigo" class="form-header">
                  Edición de Tienda
                </h5>

                <div class="row">
                  <div class="col-lg-3 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.codigo &&
                            current.errors.codigo.length > 0,
                        }"
                        >Código</label
                      >
                      <input
                        v-model="current.codigo"
                        class="form-control"
                        autofocus="autofocus"
                        :readonly="current.id != null"
                        placeholder="Código"
                        type="text"
                        v-bind:class="{
                          'is-invalid':
                            current.errors.codigo &&
                            current.errors.codigo.length > 0,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.codigo"
                        class="form-text text-danger"
                        >{{ current.errors.codigo[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-lg-9 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.nombre &&
                            current.errors.nombre.length > 0,
                        }"
                        >Nombre</label
                      >
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{
                          'is-invalid':
                            current.errors.nombre &&
                            current.errors.nombre.length > 0,
                        }"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                        >{{ current.errors.nombre[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.lista_precio &&
                            current.errors.lista_precio.length > 0,
                        }"
                        >Lista de Precio Predeterminada para Venta</label
                      >
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        v-model="current.lista_precio"
                      >
                        <option
                          v-for="(c, key) in precios"
                          :value="c.id"
                          :key="key"
                          >{{ c.id }} - {{ c.nombre }}</option
                        >
                      </select>
                      <small
                        v-if="current.errors && current.errors.lista_precio"
                        class="form-text text-danger"
                        >{{ current.errors.lista_precio[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          name="optionsRadios"
                          v-model="current.activa"
                          type="radio"
                          value="true"
                        />Activa
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          v-model="current.activa"
                          name="optionsRadios"
                          type="radio"
                          value="false"
                        />Inactiva
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          checked
                          class="form-check-input"
                          name="optionsRadiosPermitirTraslados"
                          v-model="current.permite_traslados"
                          type="radio"
                          value="true"
                        />Permite Traslados
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          v-model="current.permite_traslados"
                          name="optionsRadiosPermitirTraslados"
                          type="radio"
                          value="false"
                        />No Permite traslados
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          checked
                          class="form-check-input"
                          name="optionsRadiosListaPorCliente"
                          v-model="current.lista_precio_por_cliente"
                          type="radio"
                          value="true"
                        />Usar Listas de Precios por Cliente
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          v-model="current.lista_precio_por_cliente"
                          name="optionsRadiosListaPorCliente"
                          type="radio"
                          value="false"
                        />No Usar Listas de Precios por Cliente
                      </label>
                    </div>
                  </div>
                </div>
                <!-- desde aqui empiezan los tab encabezados -->
                <ul class="nav nav-tabs mt-3" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a
                      class="nav-link active"
                      id="contacto-tab"
                      data-toggle="tab"
                      href="#contacto"
                      role="tab"
                      aria-controls="contacto"
                      aria-selected="true"
                      >Contacto</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      id="SAT-tab"
                      data-toggle="tab"
                      href="#SAT"
                      role="tab"
                      aria-controls="SAT"
                      aria-selected="false"
                      >SAT</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      id="cuenta-tab"
                      data-toggle="tab"
                      href="#cuenta"
                      role="tab"
                      aria-controls="cuenta"
                      aria-selected="false"
                      >Bancos/Conta</a
                    >
                  </li>
                </ul>
                <!-- desde aqui empiezan los tab contenido -->

                <!-- tab contacto -->
                <div class="tab-content">
                  <div
                    class="tab-pane active"
                    id="contacto"
                    role="tabpanel"
                    aria-labelledby="contacto-tab"
                  >
                    <br /><br />
                    <div class="row">
                      <div class="col-lg-12 col-sm-8 col-md-8">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.direccion &&
                                current.errors.direccion.length > 0,
                            }"
                            >Direccion</label
                          >
                          <textarea
                            v-model="current.direccion"
                            class="form-control"
                            autofocus="autofocus"
                            placeholder="Dirección"
                            type="text"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.direccion &&
                                current.errors.direccion.length > 0,
                            }"
                          ></textarea>
                          <small
                            v-if="current.errors && current.errors.direccion"
                            class="form-text text-danger"
                            >{{ current.errors.direccion[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-4 col-md-4">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.telefono &&
                                current.errors.telefono.length > 0,
                            }"
                            >Teléfono</label
                          >
                          <input
                            v-model="current.telefono"
                            class="form-control"
                            autofocus="autofocus"
                            placeholder="Teléfono"
                            type="text"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.telefono &&
                                current.errors.telefono.length > 0,
                            }"
                          />
                          <small
                            v-if="current.errors && current.errors.telefono"
                            class="form-text text-danger"
                            >{{ current.errors.telefono[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-4 col-md-4">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.correo &&
                                current.errors.correo.length > 0,
                            }"
                            >Email</label
                          >
                          <input
                            v-model="current.correo"
                            class="form-control"
                            autofocus="autofocus"
                            placeholder="Email"
                            type="text"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.codigo &&
                                current.errors.correo.length > 0,
                            }"
                          />
                          <small
                            v-if="current.errors && current.errors.correo"
                            class="form-text text-danger"
                            >{{ current.errors.correo[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-4 col-md-4">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.codigo_postal &&
                                current.errors.codigo_postal.length > 0,
                            }"
                            >Codigo Postal</label
                          >
                          <input
                            v-model="current.codigo_postal"
                            class="form-control"
                            autofocus="autofocus"
                            placeholder="Código"
                            type="text"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.codigo_postal &&
                                current.errors.codigo_postal.length > 0,
                            }"
                          />
                          <small
                            v-if="
                              current.errors && current.errors.codigo_postal
                            "
                            class="form-text text-danger"
                            >{{ current.errors.codigo_postal[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-4 col-md-4">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.pais &&
                                current.errors.pais.length > 0,
                            }"
                            >País</label
                          >
                          <input
                            v-model="current.pais"
                            class="form-control"
                            autofocus="autofocus"
                            placeholder="País"
                            type="text"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.pais &&
                                current.errors.pais.length > 0,
                            }"
                          />
                          <small
                            v-if="current.errors && current.errors.pais"
                            class="form-text text-danger"
                            >{{ current.errors.pais[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-4 col-md-4">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.departamento &&
                                current.errors.departamento.length > 0,
                            }"
                            >Departamento</label
                          >
                          <input
                            v-model="current.departamento"
                            class="form-control"
                            autofocus="autofocus"
                            placeholder="Departamento"
                            type="text"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.departamento &&
                                current.errors.departamento.length > 0,
                            }"
                          />
                          <small
                            v-if="current.errors && current.errors.departamento"
                            class="form-text text-danger"
                            >{{ current.errors.departamento[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-4 col-md-4">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.municipio &&
                                current.errors.municipio.length > 0,
                            }"
                            >Municipio</label
                          >
                          <input
                            v-model="current.municipio"
                            class="form-control"
                            autofocus="autofocus"
                            placeholder="Municipio"
                            type="text"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.municipio &&
                                current.errors.municipio.length > 0,
                            }"
                          />
                          <small
                            v-if="current.errors && current.errors.municipio"
                            class="form-text text-danger"
                            >{{ current.errors.municipio[0] }}</small
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- tab SAT -->
                  <div
                    class="tab-pane"
                    id="SAT"
                    role="tabpanel"
                    aria-labelledby="SAT-tab"
                  >
                    <br /><br />
                    <div class="row">
                      <div class="col-sm-4 col-md-4">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.establecimiento_sat &&
                                current.errors.establecimiento_sat.length > 0,
                            }"
                            >Establecimiento de SAT</label
                          >
                          <input
                            v-model="current.establecimiento_sat"
                            class="form-control"
                            autofocus="autofocus"
                            placeholder="establecimiento de SAT"
                            type="text"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.establecimiento_sat &&
                                current.errors.establecimiento_sat.length > 0,
                            }"
                          />
                          <small
                            v-if="
                              current.errors &&
                                current.errors.establecimiento_sat
                            "
                            class="form-text text-danger"
                            >{{ current.errors.establecimiento_sat[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-4 col-md-4">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.afiliacion_iva &&
                                current.errors.afiliacion_iva.length > 0,
                            }"
                            >Afiliciacion de IVA</label
                          >
                          <input
                            v-model="current.afiliacion_iva"
                            class="form-control"
                            autofocus="autofocus"
                            placeholder="Afiliciacion de IVA"
                            type="text"
                            v-bind:class="{
                              'is-invalid':
                                current.errors.afiliacion_iva &&
                                current.errors.afiliacion_iva.length > 0,
                            }"
                          />
                          <small
                            v-if="
                              current.errors && current.errors.afiliacion_iva
                            "
                            class="form-text text-danger"
                            >{{ current.errors.afiliacion_iva[0] }}</small
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- tab cuenta -->
                  <div
                    class="tab-pane"
                    id="cuenta"
                    role="tabpanel"
                    aria-labelledby="cuenta-tab"
                  >
                    <br />
                    <br />
                    <p>Impuestos</p>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.impuesto_para_venta &&
                                current.errors.impuesto_para_venta.length > 0,
                            }"
                            >Tipo Impuesto para Venta</label
                          >
                          <select
                            class="form-control"
                            autofocus="autofocus"
                            v-model="current.impuesto_para_venta"
                          >
                            <option
                              v-for="(c, key) in tipos_impuestos_para_venta"
                              :value="c.codigo"
                              :key="key"
                              >{{ c.codigo }} - {{ c.nombre }} ({{
                                c.porc
                              }}
                              %)</option
                            >
                          </select>
                          <small
                            v-if="
                              current.errors &&
                                current.errors.impuesto_para_venta
                            "
                            class="form-text text-danger"
                            >{{ current.errors.impuesto_para_venta[0] }}</small
                          >
                        </div>
                      </div>
                    </div>
                    <hr />
                    <p>Cuentas Bancarias</p>
                    <div class="row">
                      <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.cuenta_bancaria &&
                                current.errors.cuenta_bancaria.length > 0,
                            }"
                            >Cuenta Bancaria</label
                          >
                          <select
                            class="form-control"
                            autofocus="autofocus"
                            v-model="current.cuenta_bancaria"
                          >
                            <option
                              v-for="(c, key) in cuentas_bancarias"
                              :value="c.id"
                              :key="key"
                              >{{ c.nombre }}</option
                            >
                          </select>
                          <small
                            v-if="
                              current.errors && current.errors.cuenta_bancaria
                            "
                            class="form-text text-danger"
                            >{{ current.errors.cuenta_bancaria[0] }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.cuenta_bancaria_cajas &&
                                current.errors.cuenta_bancaria_cajas.length > 0,
                            }"
                            >Cuenta Bancaria Cajas</label
                          >
                          <select
                            class="form-control"
                            autofocus="autofocus"
                            v-model="current.cuenta_bancaria_cajas"
                          >
                            <option
                              v-for="(c, key) in cuentas_bancarias"
                              :value="c.id"
                              :key="key"
                              >{{ c.nombre }}</option
                            >
                          </select>
                          <small
                            v-if="
                              current.errors &&
                                current.errors.cuenta_bancaria_cajas
                            "
                            class="form-text text-danger"
                            >{{
                              current.errors.cuenta_bancaria_cajas[0]
                            }}</small
                          >
                        </div>
                      </div>
                    </div>

                    <hr />
                    <p>Cuentas Contables</p>
                    <div class="row">
                      <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.cuenta_iva &&
                                current.errors.cuenta_iva.length > 0,
                            }"
                          >
                          </label>
                          <CuentaContableSelectComponent
                            :propname="'cuenta_iva_obj'"
                            :current="current"
                            :label="'Cuenta IVA'"
                          />
                          <small
                            v-if="current.errors.cuenta_iva"
                            class="form-text text-danger"
                            >{{ current.errors.detail }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.cuenta_iva_cxc &&
                                current.errors.cuenta_iva_cxc.length > 0,
                            }"
                          >
                          </label>
                          <CuentaContableSelectComponent
                            :propname="'cuenta_iva_cxc_obj'"
                            :current="current"
                            :label="'Cuenta IVA CXC'"
                          />
                          <small
                            v-if="current.errors.cuenta_iva_cxc"
                            class="form-text text-danger"
                            >{{ current.errors.detail }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.cuenta_cxc &&
                                current.errors.cuenta_cxc.length > 0,
                            }"
                          >
                          </label>
                          <CuentaContableSelectComponent
                            :propname="'cuenta_cxc_obj'"
                            :current="current"
                            :label="'Cuenta IVA CXC'"
                          />
                          <small
                            v-if="current.errors.cuenta_cxc"
                            class="form-text text-danger"
                            >{{ current.errors.detail }}</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                          <label
                            v-bind:class="{
                              'text-danger':
                                current.errors.cuenta_descto_merca &&
                                current.errors.cuenta_descto_merca.length > 0,
                            }"
                          >
                          </label>
                          <CuentaContableSelectComponent
                            :propname="'cuenta_descto_merca_obj'"
                            :current="current"
                            :label="'Cuenta IVA CXC'"
                          />
                          <small
                            v-if="current.errors.cuenta_descto_merca"
                            class="form-text text-danger"
                            >{{ current.errors.detail }}</small
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- AQUI TERMINA TAB -->
                </div>

                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link
                    class="btn btn-default"
                    :to="{ name: 'cat-tiendas', params: {} }"
                  >
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import CuentaContableSelectComponent from "@/components/commons/CuentaContableSelectComponent";
import TiendaService from "@/services/catalogos/TiendaService";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    CuentaContableSelectComponent,
  },
  data() {
    return {
      current: {
        errors: {},
      },
      tipos_impuestos_para_venta: [],
    };
  },

  computed: {
    ...mapGetters({
      precios: "catalogos/lista_precio",
      cuentas_bancarias: "catalogos/cuentas_bancarias",
    }),
  },
  mounted() {
    let self = this;
    DynamicService.fetch("cat", "tipo-impuesto", {
      quitar_paginacion: true,
    }).then((res) => {
      self.tipos_impuestos_para_venta = res.data;
    });
    if (self.$route.params.id) {
      TiendaService.getById(self.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.id = self.$route.params.id;
        self.current.errors = [];
      });
    }
    self.refreshSelectores();

    self.refreshData();
  },

  methods: {
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, this.current);

      let value = current.cuenta_iva_obj;
      if (value && typeof value === "object" && value.constructor === Object) {
        current.cuenta_iva = current.cuenta_iva_obj.id;
      }
      value = current.cuenta_iva_cxc_obj;
      if (value && typeof value === "object" && value.constructor === Object) {
        current.cuenta_iva_cxc = current.cuenta_iva_cxc_obj.id;
      }
      value = current.cuenta_cxc_obj;
      if (value && typeof value === "object" && value.constructor === Object) {
        current.cuenta_cxc = current.cuenta_cxc_obj.id;
      }
      value = current.cuenta_descto_merca_obj;
      if (value && typeof value === "object" && value.constructor === Object) {
        current.cuenta_descto_merca = current.cuenta_descto_merca_obj.id;
      }
      TiendaService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Tienda",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-tiendas-editar",
            params: { id: self.current.codigo },
          });
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            self.current.errors = error.response.data;
          }
        });
    },
    refreshSelectores() {
      let self = this;
      self.$store.dispatch("catalogos/lista_precio", {
        activa: true,
        quitar_paginacion: true,
      });
      self.$store.dispatch("catalogos/cuentas_bancarias", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    showModal(e) {
      e.preventDefault();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activa: this.filterActivo,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activa: this.filterActivo,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activa: this.filterActivo,
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
    },
  },
};
</script>
